export default __webpack_public_path__ + "static/media/experimentation.be295c7a.svg";